import React from "react";
import PropTypes from "prop-types";

export const STATUS_TYPES = [
  "secondary",
  "success",
  "warning",
  "error",
  "bid",
  "offer",
  "draft",
  "created",
  "checked",
  "published",
  "in-use",
  "returned",
  "cancelled",
  "rejected",
  "void",
];

const StatusBadge = ({
  children,
  className = "",
  customColor,
  customForeground = "var(--neutral-0)",
  label,
  type = "secondary",
}) => {
  const statusType = STATUS_TYPES.includes(type) ? type : "secondary";
  const classes = [
    "status-badge",
    `status-badge--${statusType}`,
    className,
  ].filter(Boolean);

  const customStyle = customColor
    ? {
        "--status-badge-background": customColor,
        "--status-badge-foreground": customForeground,
      }
    : undefined;

  return (
    <span className={classes.join(" ")} style={customStyle}>
      {label ?? children}
    </span>
  );
};

StatusBadge.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  customColor: PropTypes.string,
  customForeground: PropTypes.string,
  label: PropTypes.node,
  type: PropTypes.oneOf(STATUS_TYPES),
};

export default StatusBadge;
